import React from 'react';
import { ModalUI } from '../../common';
import { withStyles } from '@material-ui/core';

const ModalUninstallApp_ = ({ open, modalHandler, classes, history }) => {
  const handleSubmitUninstallApp = (e) => {
    e.preventDefault();
    history.push('/soporte');
  };

  return (
    <ModalUI
      id="modal-ecommapp-uninstall"
      open={open}
      button_loading={false}
      title="Desinstalar la app"
      button_label={'Continuar'}
      modalHandler={modalHandler}
      cancel_button_label="Cancelar"
      handleSubmit={handleSubmitUninstallApp}
      classes={{ card_actions: classes.containerButtons }}
    >
      <p className={classes.modalText}>
        Para desinstalar la aplicación, envianos un mensaje desde el Centro de
        Ayuda.
      </p>
    </ModalUI>
  );
};

const styles = () => ({
  modalText: {
    color: '#565656',
    fontSize: '1.12rem',
    fontWeight: 400,
    margin: 0,
  },
  containerButtons: {
    '& div': { gap: '5px' },
  },
});

export const ModalUninstallApp = withStyles(styles)(ModalUninstallApp_);
